import type { IMoneySourceInfo } from '../../../../repositories/billing-tariffs/entities/PublishTerms/MoneySourceInfo';
import { TMoneySourcesState } from '../../../../reducers/v2';

export function mapMoneySources(sources: IMoneySourceInfo[]): TMoneySourcesState {
  return sources.map(source => ({
    type: source.moneySource,
    disabled: source.isDisabled,
    selected: source.isSelected,
  }));
}
